import request from './request'

export function listScheduleTasks(data) {
  return request.post('/production/order-tasks/list', data)
}
export function updateSchedule(data) {
  return request.post('/production/order-tasks/update-schedule', data)
}
export function findScheduleConflicts(data) {
  return request.post('/production/order-tasks/conflicts', data || {})
}
export function autoScheduleOrder(orderId, hoursPerOp) {
  return request.post('/production/order-tasks/auto-schedule', { orderId, hoursPerOp })
}
export function listGanttBars(data) {
  return request.post('/production/order-tasks/gantt', data)
}
export function listTimeGaps(data) {
  return request.post('/production/order-tasks/time-gaps', data)
}
